/**
 * Formie field modifications
 *
 * Behaviour for our own CSS modifiers on Formie fields (e.g. `.as-pill-slider`)
 * that native Formie/vendor markup doesn't provide on its own. One function
 * per modifier, called from init() below.
 */

// .fui-type-radio.as-pill-slider - a sliding pill background tracks whichever
// option is currently checked. --w/--h/--x/--y describe that option's box
// relative to the track, so the CSS side can position/size a single pill
// element with a transform instead of restyling per-option backgrounds.
const initPillSlider = (root = document) => {
    root.querySelectorAll('.fui-type-radio.as-pill-slider').forEach(($field) => {
        if ($field.dataset.pillSliderReady) return
        $field.dataset.pillSliderReady = 'true'

        const $track = $field.querySelector('.fui-layout-wrap')
        if (!$track) return

        const position = () => {
            const $checked = $track.querySelector('.fui-radio-input:checked')
            const $option = $checked?.closest('.fui-radio')
            if (!$option) return

            const trackRect = $track.getBoundingClientRect()
            const optionRect = $option.getBoundingClientRect()

            // A zero-sized rect means the track is mid-layout (e.g. its Formie
            // page just switched from hidden to visible) - not a real position.
            // Writing it would move the pill through a bogus 0/0/0/0 state;
            // skip it and keep the last-known-good position until a real
            // measurement comes in.
            if (!optionRect.width || !optionRect.height) return

            $track.style.setProperty('--w', `${optionRect.width}px`)
            $track.style.setProperty('--h', `${optionRect.height}px`)
            $track.style.setProperty('--x', `${optionRect.left - trackRect.left}px`)
            $track.style.setProperty('--y', `${optionRect.top - trackRect.top}px`)
        }

        // The pill has no transition by default - only a genuine user click
        // (the 'change' event) should animate it. Every other re-sync (initial
        // mount, a Formie page being revealed, viewport resize) is the
        // ResizeObserver correcting the track's own layout, not a user
        // picking an option, so it must snap instantly.
        $track.addEventListener('change', () => {
            $track.classList.add('pill-slider--animate')
            position()
        })

        new ResizeObserver(() => {
            $track.classList.remove('pill-slider--animate')
            position()
        }).observe($track)

        position()
    })
}

const init = (root = document) => {
    initPillSlider(root)
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init())
} else {
    init()
}

export default init
